<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h14">Acknowledgments</h1>
<p class="p5"><img alt="img2.png" src="images/img2.png"/></p>
<p class="p6"> </p>
<p class="p6"><span class="t4">T</span><span class="t5">HIS</span><span class="t4"> </span><span class="t5">BOOK</span><span class="t4"> </span>was a long time in the making. I want to thank everyone who supported me throughout the writing of it, especially Carol, who has read who knows how many versions. I also want to thank Sasha for believing in this world. Lastly, I couldn’t do what I do without the support of my family. Love you!</p>
<p class="p7"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?00c1c806